



















































import { Component, Vue } from "vue-property-decorator";
import ShiftRender from "@/components/render/ShiftRender.vue";
import MenuRender from "@/components/render/MenuRender.vue";
import { RenderChannelModel, RenderPostModel } from "@/services/render/types";
import { renderChannel } from "@/services/render/renderService";
import { InteractionTypes, isShift } from "@/services/channels/types";
import { Getter } from "vuex-class";
import PreviewModalHeader from "@/components/common/preview/PreviewModalHeader.vue";
import PreviewSidebar from "@/components/common/preview/PreviewSidebar.vue";
import SolutionRender from "@/components/render/SolutionRender.vue";
import { Solution } from "@/services/solutions/types";
const namespace: string = "authentication";

@Component({
    components: {
        ShiftRender,
        PreviewModalHeader,
        MenuRender,
        PreviewSidebar,
        SolutionRender
    }
})
export default class ChannelPreviewModal extends Vue {
    @Getter("getToken", { namespace }) getToken!: string;

    // local
    channelId = "";
    shiftRenderModel = {
        height: 0,
        width: 0,
        renderPosts: [] as Array<RenderPostModel>
    } as RenderChannelModel;

    shiftRenderReload = 0;
    scale = 1;
    dateTime = "";
    fitScale = 0;
    bgColor = "#ffffff";
    channelName = "";
    allowTransition = false;
    interactionTypes = InteractionTypes;
    isShift = isShift;

    open(channelId: string, name: string) {
        this.allowTransition = false;
        this.channelId = channelId;
        this.channelName = name;
        this.$bvModal.show("modal-channelPreview");
    }

    hide() {
        this.channelId = "";
        this.$bvModal.hide("modal-channelPreview");
    }

    renderChannel(value: string, keepZoom = false) {
        this.dateTime = value;
        renderChannel(this.channelId, this.dateTime).then(
            response => {
                this.shiftRenderReload += 1;
                this.shiftRenderModel = response;
                const oldScale = this.scale;
                this.setScale(this.shiftRenderModel.width, this.shiftRenderModel.height);
                if (keepZoom) this.scale = oldScale;
                if (this.shiftRenderModel.renderPosts[0]) (this.$refs.header as any).checkBackgroundColor(this.shiftRenderModel.renderPosts[0]);
            }
        );
    }

    onScale(value: number) {
        this.scale = value;
        this.allowTransition = true;
    }

    changeBg(color: string) {
        this.bgColor = color;
    }

    fullScreen() {
        return { name: "channelPreview", params: { channelId: this.channelId } };
    }

    setScale(width: number, height: number) {
        var scaleX = (window.innerWidth / 100 * 70) / width;
        var scaleY = (window.innerHeight / 100 * 74) / height;
        this.scale = scaleX <= scaleY ? scaleX : scaleY;
        this.scale = this.scale >= 1 ? 1 : this.scale;
        this.scale = Math.floor(this.scale * 100) / 100;
        this.fitScale = this.scale;
    }

    scaleFit() {
        this.scale = this.fitScale;
    }

    // computed
    get model(): RenderChannelModel {
        if (this.shiftRenderModel.renderPosts.length > 0) {
            return this.shiftRenderModel;
        } else {
            return undefined!;
        };
    }

    get adaptedSize() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "left top",
            height: `${this.shiftRenderModel.height}px`,
            width: `${this.shiftRenderModel.width}px`
        };
    }

    // solution preview
    solutionPreview = false;
    selectedSolution = {} as Solution;

    loadSolutionPreview(solution: Solution) {
        this.selectedSolution = solution;
        this.setScale(this.selectedSolution.width, this.selectedSolution.height);
        this.solutionPreview = true;
    }

    clearSolutionPreview() {
        this.setScale(this.shiftRenderModel.width, this.shiftRenderModel.height);
        this.selectedSolution = {} as Solution;
        this.solutionPreview = false;
    }

    get solutionAdaptedSize() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "left top",
            height: `${this.selectedSolution.height}px`,
            width: `${this.selectedSolution.width}px`
        };
    }

    clearState() {
        this.channelId = "";
        this.channelName = "";
        this.shiftRenderModel = {
            height: 0,
            width: 0,
            renderPosts: [] as Array<RenderPostModel>
        } as RenderChannelModel;
        this.solutionPreview = false;
        this.selectedSolution = {} as Solution;
    }
}
